module.exports = __webpack_public_path__ + "static/img/test.0cb14291.png";